import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mafc/trolly';

import { Price } from 'network/response/ICart';
import { getFormattedPrice } from 'utils/price.util';

import { getProperNoun } from 'utils/helpers.util';
import COLORS from 'theme/colors';

const Stripe = ({
  yearOfWarranty,
  price,
  onClick,
  variant,
  isChecked,
}: {
  yearOfWarranty: number;
  price: Price;
  onClick: () => void;
  variant: 'success' | 'info';
  isChecked?: boolean;
}) => {
  const colors = useMemo(
    () => ({
      success: {
        color: COLORS.SUCCESS_600,
        bgColor: COLORS.SUCCESS_25,
      },
      info: {
        color: COLORS.INFO_600,
        bgColor: COLORS.INFO_25,
      },
    }),
    []
  );
  const { color, bgColor } = colors[variant];
  const { t } = useTranslation();

  const textToShow = useMemo(() => {
    if (!isChecked) {
      return getProperNoun(
        yearOfWarranty,
        t('addExtendedWarrantyMsg', {
          count: yearOfWarranty,
          cost: getFormattedPrice(price, false, true, true),
        }),
        t('addExtendedWarrantyMsgPlural', {
          count: yearOfWarranty,
          cost: getFormattedPrice(price, false, true, true),
        })
      );
    }
    return t('extendedWarrantySelected', {
      count: yearOfWarranty,
      cost: getFormattedPrice(price, false, true, true),
    });
  }, [isChecked, price, t, yearOfWarranty]);
  return (
    <>
      <Box
        sx={{
          padding: '12px 16px',
          lineHeight: ' 20px',
          background: bgColor,
          fontSize: ' 14px',
          color,
          fontWeight: ' 400',
          borderRadius: ' 4px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box mr={1} display="inline-block">
          {textToShow}
        </Box>
        <Button
          variant="link"
          onClick={onClick}
          fontWeight="700"
          height="auto"
          data-testid="add-remove"
        >
          <Box as="span" color={color}>
            {isChecked ? t('remove') : t('add')}
          </Box>
        </Button>
      </Box>
    </>
  );
};

export default React.memo(Stripe);
